/**
 * `getVideoMetadata` / `getAudioMetadata` 와 그 변형 (Remotion 에디터의
 * `make-item-wkwk.ts`, `gts-video-auto-load.tsx`) 에서 reject 시 던지는 에러
 * 메시지의 단일 소스. `upload-error-classifier` 가 이 상수를 사용해 reason
 * 분류를 수행하므로, 메시지 문자열 변경 시 분류기와 함께 수정해야 한다.
 */
export const FILE_METADATA_ERROR_MESSAGES = {
  NOT_VIDEO: 'File is not video.',
  NOT_AUDIO: 'File is not an audio file.',
  VIDEO_DURATION_UNRESOLVED: 'Could not resolve valid video duration.',
  AUDIO_DURATION_UNRESOLVED: 'Could not resolve valid audio duration.',
  AUDIO_LOAD_FAILED: 'Could not load audio metadata.',
  VIDEO_LOAD_PREFIX: 'Could not load video metadata.',
} as const;

export const formatVideoMetadataLoadError = (
  code: number | undefined,
  message: string | undefined,
): string =>
  `${FILE_METADATA_ERROR_MESSAGES.VIDEO_LOAD_PREFIX} Code: ${code}, Message: ${message}`;
